import { render, staticRenderFns } from "./profile-files.vue?vue&type=template&id=f76d195c&"
import script from "./profile-files.vue?vue&type=script&lang=js&"
export * from "./profile-files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports